import { api } from './client';

export const templatesApi = {
  list: (category) =>
    api.get('/templates', { params: category ? { category } : {} }).then((r) => r.data),
  get: (slug) => api.get(`/templates/${slug}`).then((r) => r.data),
};